module.exports = __webpack_public_path__ + "static/media/img2.60bc53db.svg";